import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

const MileageContainer = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing.S8};
  grid-template-columns: 1fr 104px;
`;

export { Form, MileageContainer };
